module.exports = __webpack_public_path__ + "static/media/bl4.456138b7.jpg";